import { render, staticRenderFns } from "./ContributorHeader.vue?vue&type=template&id=cf2acd8c&scoped=true&"
import script from "./ContributorHeader.vue?vue&type=script&lang=js&"
export * from "./ContributorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContributorHeader.vue?vue&type=style&index=0&id=cf2acd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2acd8c",
  null
  
)

export default component.exports